<template>
  <div>
    <v-skeleton-loader v-if="loading" type="list-item-two-line, list-item, list-item" />
    <div v-else class="notification-section">
      <div class="d-flex align-center mb-1">
        <BellRing class="section-icon mr-3" :size="22" />
        <h2 class="section-title">{{ $gt('Benachrichtigungen') }}</h2>
      </div>
      <p class="section-subtitle mb-4">
        {{ $gt('Wählen Sie, worüber Sie in der Sammel-Benachrichtigung informiert werden möchten. Neue Eintragungen werden alle 30 Minuten zusammengefasst.') }}
      </p>

      <div class="pref-list">
        <label v-for="p in prefs" :key="p.topic" class="pref-row">
          <input
            type="checkbox"
            :checked="p.enabled"
            :disabled="saving"
            @change="toggle(p)"
          >
          <span>{{ $gt(p.label) }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
// Benachrichtigungs-Einstellungen pro Nutzer (Issue #899): Themen-Auswahl
// für den 30-Min-Digest. Änderungen werden sofort gespeichert.
import { BellRing } from "lucide-vue-next";
import { getRequestGeneric, putRequestGeneric } from "@/services/backendApiGeneric";
import { useSnackbarStore } from "@/stores/snackbarStore.ts";

export default {
  name: "NotificationSection",
  components: { BellRing },

  data() {
    return {
      prefs: [],
      loading: false,
      saving: false,
    };
  },

  async mounted() {
    this.loading = true;
    try {
      this.prefs = await getRequestGeneric("/protected/notification-preferences") || [];
    } catch {
      this.prefs = [];
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async toggle(pref) {
      const previous = pref.enabled;
      pref.enabled = !previous;
      this.saving = true;
      try {
        await putRequestGeneric("/protected/notification-preferences",
          [{ topic: pref.topic, enabled: pref.enabled }], true);
      } catch (e) {
        pref.enabled = previous;
        useSnackbarStore().showSnackbar({ message: e.message, type: "error" });
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.section-icon {
  color: var(--primary-color);
}
.section-title {
  font-size: 1.05rem;
  font-weight: 600;
}
.section-subtitle {
  font-size: 0.85rem;
  color: var(--grey-color);
}
.pref-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.pref-row {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.9rem;
  cursor: pointer;
  user-select: none;
}
.pref-row input {
  accent-color: var(--primary-color);
  cursor: pointer;
}
</style>
